import { ErrorOutline, Flag, ReportProblem, Warning } from '@mui/icons-material';
import { formatDate } from '../../../utils/dateUtils';

export const severityColor = (severity) => {
  switch (severity.toLowerCase()) {
    case 'critical':
      return 'red';
    case 'major':
      return 'orange';
    case 'minor':
      return 'green'; 
    default:
      return '#e0e0e0';
  }
};

export const severityIcon = (severity) => {
  switch (severity) {
    case 'critical':
      return <Flag sx={{ color: severityColor(severity), fontSize: '15px', ml: 1, alignItems: 'center' }} />;
    case 'major':
      return <Flag sx={{ color: severityColor(severity), fontSize: '15px', ml: 1, alignItems: 'center' }} />;
    case 'minor':
      return <Flag sx={{ color: severityColor(severity), fontSize: '15px', ml: 1, alignItems: 'center' }} />;
    default:
      return null;
  }
};

export const groupAnnouncementsByDate = (announcements) => {
  const groups = {};
  announcements?.forEach((announcement) => {
    const dateStr = formatDate(announcement.datePosted);
    if (!groups[dateStr]) {
      groups[dateStr] = [];
    }
    groups[dateStr].push(announcement);
  });
  return groups;
};
